import { ILibraryListItem } from "@/api";

const LABELS: Record<string, [string, string]> = {
    folder: ["folder", "folders"],
    document: ["document", "documents"],
    scope: ["scope", "scopes"],
    comparison: ["comparison", "comparisons"],
};

export const formatItemSummary = (items: ILibraryListItem[]): string => {
    const counts: Record<string, number> = {};
    for (const item of items) {
        counts[item.type] = (counts[item.type] ?? 0) + 1;
    }
    const parts: string[] = [];
    for (const [type, [singular, plural]] of Object.entries(LABELS)) {
        const count = counts[type];
        if (count) parts.push(`${count} ${count === 1 ? singular : plural}`);
    }
    if (parts.length <= 1) return parts[0] ?? "";
    return parts.slice(0, -1).join(", ") + " and " + parts[parts.length - 1];
};
